/** Shared Empty State component — Addendum 44 */
import React from 'react';
import { Button } from '../components/ui/button';

const ILLUSTRATIONS = {
  content: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="50" fill="var(--color-warm-accent-light)" />
      <path d="M45 75L70 40" stroke="var(--color-warm-accent)" strokeWidth="3" strokeLinecap="round" />
      <path d="M70 40L75 35" stroke="var(--color-warm-accent)" strokeWidth="3" strokeLinecap="round" />
      <circle cx="43" cy="77" r="3" fill="var(--color-warm-accent)" />
      <circle cx="80" cy="30" r="2" fill="#F5A623" opacity="0.8" />
      <circle cx="85" cy="40" r="1.5" fill="#E91E8C" opacity="0.6" />
      <circle cx="75" cy="25" r="1.5" fill="#7CB342" opacity="0.7" />
    </svg>
  ),
  research: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="50" fill="var(--color-warm-accent-light)" />
      <circle cx="52" cy="52" r="18" stroke="var(--color-warm-accent)" strokeWidth="3" fill="none" />
      <path d="M65 65L78 78" stroke="var(--color-warm-accent)" strokeWidth="3" strokeLinecap="round" />
      <circle cx="52" cy="52" r="6" fill="var(--color-warm-accent)" opacity="0.15" />
      <circle cx="38" cy="38" r="2" fill="#7CB342" opacity="0.7" />
      <circle cx="66" cy="38" r="2" fill="#E91E8C" opacity="0.6" />
      <circle cx="52" cy="70" r="1.5" fill="#F5A623" opacity="0.8" />
    </svg>
  ),
  calendar: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="50" fill="var(--color-warm-accent-light)" />
      <rect x="35" y="40" width="50" height="40" rx="4" stroke="var(--color-warm-accent)" strokeWidth="2.5" fill="none" />
      <path d="M35 52H85" stroke="var(--color-warm-accent)" strokeWidth="2" />
      <circle cx="48" cy="62" r="3" fill="#2563EB" opacity="0.8" />
      <circle cx="60" cy="62" r="3" fill="#E8875B" opacity="0.8" />
      <circle cx="72" cy="62" r="3" fill="#7CB342" opacity="0.8" />
      <circle cx="48" cy="72" r="2" fill="#E91E8C" opacity="0.5" />
      <path d="M45 36V44" stroke="var(--color-warm-accent)" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M75 36V44" stroke="var(--color-warm-accent)" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  ),
  sequence: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="50" fill="var(--color-warm-accent-light)" />
      <circle cx="35" cy="60" r="8" stroke="var(--color-warm-accent)" strokeWidth="2.5" fill="none" />
      <circle cx="55" cy="60" r="8" stroke="#2563EB" strokeWidth="2.5" fill="none" />
      <circle cx="75" cy="60" r="8" stroke="#7CB342" strokeWidth="2.5" fill="none" />
      <path d="M43 60H47" stroke="var(--color-muted)" strokeWidth="1.5" />
      <path d="M63 60H67" stroke="var(--color-muted)" strokeWidth="1.5" />
      <circle cx="90" cy="60" r="4" fill="var(--color-warm-accent)" opacity="0.3" />
    </svg>
  ),
  events: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="50" fill="var(--color-warm-accent-light)" />
      <rect x="38" y="55" width="16" height="24" rx="2" stroke="var(--color-warm-accent)" strokeWidth="2" fill="none" />
      <rect x="58" y="48" width="16" height="31" rx="2" stroke="#E91E8C" strokeWidth="2" fill="none" />
      <rect x="78" y="52" width="6" height="27" rx="2" stroke="#7CB342" strokeWidth="2" fill="none" />
      <path d="M35 79H90" stroke="var(--color-warm-accent)" strokeWidth="2" />
      <circle cx="46" cy="44" r="5" stroke="var(--color-warm-accent)" strokeWidth="1.5" fill="none" />
      <circle cx="66" cy="38" r="5" stroke="#E91E8C" strokeWidth="1.5" fill="none" />
    </svg>
  ),
  pipeline: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="50" fill="var(--color-warm-accent-light)" />
      <path d="M40 38L60 38L80 38" stroke="var(--color-warm-accent)" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M45 55L60 55L75 55" stroke="var(--color-warm-accent)" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M50 72L60 72L70 72" stroke="var(--color-warm-accent)" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="60" cy="82" r="5" fill="var(--color-success)" opacity="0.7" />
      <circle cx="40" cy="38" r="4" fill="#2563EB" opacity="0.8" />
      <circle cx="60" cy="55" r="4" fill="#D97706" opacity="0.8" />
      <circle cx="60" cy="72" r="4" fill="#7CB342" opacity="0.8" />
    </svg>
  ),
  crm: (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="50" fill="var(--color-warm-accent-light)" />
      <circle cx="45" cy="50" r="10" stroke="var(--color-warm-accent)" strokeWidth="2" fill="none" />
      <circle cx="60" cy="45" r="10" stroke="#2563EB" strokeWidth="2" fill="none" />
      <circle cx="75" cy="50" r="10" stroke="#7CB342" strokeWidth="2" fill="none" />
      <circle cx="45" cy="50" r="3" fill="var(--color-warm-accent)" opacity="0.6" />
      <circle cx="60" cy="45" r="3" fill="#2563EB" opacity="0.6" />
      <circle cx="75" cy="50" r="3" fill="#7CB342" opacity="0.6" />
      <path d="M40 72C40 66 50 64 60 64C70 64 80 66 80 72" stroke="var(--color-muted)" strokeWidth="1.5" fill="none" />
    </svg>
  ),
};

const EMPTY_CONFIGS = {
  content: {
    title: 'Il tuo primo contenuto parte da qui',
    text: 'Scegli un tema, configura le variabili, e lascia che il Copywriter crei il post perfetto per il tuo brand.',
    button: '+ Crea il primo contenuto',
  },
  research: {
    title: 'Esplora il tuo mercato',
    text: 'Avvia una ricerca guidata per trovare trend, competitor, e fonti da usare nei tuoi contenuti.',
    button: 'Avvia la prima ricerca',
  },
  calendar: {
    title: 'La settimana è tutta da pianificare',
    text: 'Crea la tua prima sequenza o aggiungi contenuti al calendario per organizzare la comunicazione.',
    button: '+ Nuova sequenza',
  },
  sequence: {
    title: 'Le sequenze rendono la comunicazione costante',
    text: 'Una sequenza è una serie di post collegati da un filo conduttore. Definisci il tema e le date, poi genera i contenuti.',
    button: '+ Crea la prima sequenza',
  },
  events: {
    title: 'Organizza il tuo prossimo evento',
    text: 'Workshop, webinar, meetup \u2014 progetta l\'evento, definisci il programma, e genera automaticamente il piano di promozione.',
    button: '+ Crea il primo evento',
  },
  pipeline: {
    title: 'La pipeline si riempie con le relazioni',
    text: 'Ogni conversazione con un potenziale cliente diventa un deal. Trascinalo tra le fasi fino alla chiusura.',
    button: '+ Nuovo deal',
  },
  crm: {
    title: 'I tuoi contatti sono al centro di tutto',
    text: 'Importa i contatti da un CSV o aggiungili manualmente. Ogni contatto diventa una storia di interazioni.',
    button: 'Importa contatti',
  },
};

export default function EmptyState({ type = 'content', onAction, buttonText, title, text }) {
  const config = EMPTY_CONFIGS[type] || EMPTY_CONFIGS.content;
  const illustration = ILLUSTRATIONS[type] || ILLUSTRATIONS.content;
  
  return (
    <div className="empty-state" data-testid={`empty-state-${type}`}>
      {illustration}
      <h3>{title || config.title}</h3>
      <p>{text || config.text}</p>
      {onAction && (
        <Button
          onClick={onAction}
          className="mt-4"
          data-testid={`empty-state-${type}-action`}
          style={{ borderRadius: 'var(--radius-soft)', fontSize: '13px', fontWeight: 600 }}
        >
          {buttonText || config.button}
        </Button>
      )}
    </div>
  );
}
